import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import DropdownOptions from "../../../constants/DropdownOptions";
import * as contractActions from "../../../modules/contract/action";
import "../../../style";
import AllMainFarmSelectedDialog from "../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import TabHeaderAndButton from "../../Common/TabHeaderAndButton";
import CreateTable from "../../CreateTable";
import ConfirmationDialog from "../../FormElement/ConfirmationDialog";
import InputFiled from "../../FormElement/InputFiled";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";

class ContractView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      headerRows: {
        updatedAt: "Last Updated",
        updatedBy: "Updated By",
        contractNumber: "Contract Number",
        counterpartResponseDTO: "Counterpart",
        contractType: "Type",
        commodityResponseDTO: "Commodity",
        maturityDate: "Maturity Date",
        contractStageResponseDTO: "Stage",
        contractValue: "Value"
      },
      order: "desc",
      orderBy: "",
      open: false,
      searchTerm: this.props.searchTerm || "",
      typingTimeout: 0
      // fetchingSubFarmId: false
    };
  }

  componentWillMount() {
    let farmId = this.props.SubFarmId
      ? this.props.SubFarmId
      : userFarmDetail().id
      ? userFarmDetail().id
      : this.props.MainFarmId;
    if (farmId !== DropdownOptions.ALL_MAIN_FARM.id) {
      const { selectedYear, searchTerm } = this.props;
      this.props.actions.getContractList(
        farmId,
        selectedYear,
        undefined,
        undefined,
        searchTerm
      );
      searchTerm && this.props.actions.setSearchTerm("");
    }
  }

  handleNextPage = (page, rowsPerPage) => {
    let farmId = this.props.SubFarmId
      ? this.props.SubFarmId
      : userFarmDetail().id
      ? userFarmDetail().id
      : this.props.MainFarmId;
    if (farmId !== DropdownOptions.ALL_MAIN_FARM.id) {
      const { searchTerm } = this.state;
      const { selectedYear } = this.props;
      this.props.actions.getContractList(
        farmId,
        selectedYear,
        page,
        rowsPerPage,
        searchTerm
      );
    }
  };

  componentWillReceiveProps(nextProps) {
    let farmId = this.props.SubFarmId
      ? nextProps.SubFarmId
      : userFarmDetail().id;
    if (
      nextProps.ContractList &&
      this.props.ContractList !== nextProps.ContractList &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
    if (
      nextProps.SubFarmId &&
      nextProps.SubFarmId !== this.props.SubFarmId &&
      nextProps.SubFarmId !== DropdownOptions.ALL_MAIN_FARM.id
    ) {
      this.props.actions.getContractList(
        nextProps.SubFarmId,
        this.selectedYear
      );
      this.setState({ searchTerm: "" });
    }
    if (
      nextProps.selectedYear &&
      nextProps.selectedYear !== this.props.selectedYear &&
      (!isSuperAdmin() || farmId !== DropdownOptions.ALL_MAIN_FARM.id)
    ) {
      this.props.actions.getContractList(farmId, nextProps.selectedYear);
      this.setState({ searchTerm: "" });
    }
  }
  componentWillUnmount() {
    this.props.actions.clearErrorMessage();
  }

  craeteRowData = rowData => {
    return (
      rowData &&
      Object.keys(rowData).map(value => {
        let CurrentRow = rowData[value];
        let obj = {};
        obj["fullData"] = CurrentRow;
        obj["updatedAt"] = moment(CurrentRow.updatedAt).format("ll");
        obj["updatedBy"] = CurrentRow.updatedBy;
        obj["maturityDate"] = moment(CurrentRow.maturityDate).format("ll");
        obj["lastUpdated"] = new Date(CurrentRow.updatedAt).getTime();
        obj["contractNumber"] = CurrentRow.contractNumber;
        obj["counterpartResponseDTO"] = CurrentRow.counterpartResponseDTO
          ? CurrentRow.counterpartResponseDTO.name
          : "";
        obj["contractType"] = CurrentRow.contractType
          ? CurrentRow.contractType.type
          : "";
        obj["commodityResponseDTO"] = CurrentRow.commodityVarietyResponseDTO
          ? CurrentRow.commodityVarietyResponseDTO.commodityResponseDTO.name
          : "";
        obj["contractStageResponseDTO"] =
          CurrentRow.contractStageResponseDTO.stage;
        obj["contractValue"] = `$${CurrentRow.contractValue}`;
        obj["id"] = CurrentRow.id;
        obj["disabled"] = CurrentRow.disable;
        return obj;
      })
    );
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  deleteRow = id => {
    this.setState({
      open: true,
      id: id
    });
  };

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  handleOk = () => {
    const { id } = this.state;
    this.handleClose();
    this.props.actions.deleteContract(id);
  };

  editRow = (id, data) => {
    this.props.actions.setSearchTerm(this.state.searchTerm);

    this.props.actions.editSelectedContract(data);
  };

  handleChange = event => {
    const keyword = event.target.value;
    if (keyword.match(/^(\w|-){0,21}$/)) {
      const { typingTimeout } = this.state;
      let farmId = this.props.SubFarmId
        ? this.props.SubFarmId
        : userFarmDetail().id || this.props.MainFarmId;

      const { selectedYear, actions } = this.props;
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
      this.setState({
        searchTerm: keyword,
        typingTimeout: setTimeout(function() {
          keyword
            ? actions.getContractList(
                farmId,
                selectedYear,
                undefined,
                undefined,
                keyword
              )
            : actions.getContractList(farmId, selectedYear);
        }, 1000)
      });
    }
  };

  render() {
    const { order, orderBy, open, searchTerm } = this.state;
    const {
      ContractList,
      ErrorMessage,
      pageCount,
      totalElements,
      fetchingComplete
    } = this.props;
    console.log(this.props);
    return (
      <div className="ticket-body">
        <ConfirmationDialog
          open={open}
          handleClose={this.handleClose}
          handleOk={this.handleOk}
        />
        <TabHeaderAndButton
          header="Contracts"
          path="/app/createcontract"
          btnLabel="New contract"
          searchField={
            <InputFiled
              value={searchTerm}
              placeholder="Search Contract..."
              handleChange={this.handleChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
            />
          }
          isDisabled={
            isSuperAdmin() &&
            this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id
          }
        />
        {isSuperAdmin() &&
        this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? (
          <AllMainFarmSelectedDialog />
        ) : (
          <div>
            {/* {fetchingComplete ? ( */}
            <CreateTable
              orderBy={orderBy}
              order={order}
              onRequestSort={this.handleRequestSort}
              headerRows={this.state.headerRows}
              rowData={this.craeteRowData(ContractList) || []}
              location="app/editcontract"
              delete={this.deleteRow}
              edit={this.editRow}
              highlightPrimaryColumn={true}
              fetchingComplete={fetchingComplete}
              pageCount={pageCount}
              totalElements={totalElements}
              handleNextPage={this.handleNextPage}
            />
            {/* ) : (
              <Loader />
            )} */}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    user: state.user,
    ContractList: state.contractReducer.ContractList,
    fetchingComplete: state.contractReducer.fetchingComplete,
    pageCount: state.contractReducer.pageCount,
    totalElements: state.contractReducer.totalElements,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear,
    searchTerm: state.contractReducer.searchTerm
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...contractActions
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContractView);



// WEBPACK FOOTER //
// ./src/components/private/Contracts/ContractView.js